import { API_ROOT } from 'configs/env-vars';
import { makeRequestAction } from './index';

export const sendDealEmail = makeRequestAction('SEND_DEAL_EMAIL', {
  onSuccess(params, response) {
    return {
      response: {
        ...response,
      },
    };
  },
});

export const sendApprovalEmail = makeRequestAction('SEND_APPROVAL_EMAIL', {
  onSuccess(params, response) {
    return {
      response: {
        ...response,
      },
    };
  },
});

export const checkDealEmailLimit = makeRequestAction('CHECK_DEAL_EMAIL_LIMIT', {
  onSuccess(params, response) {
    return {
      response: {
        ...response,
      },
    };
  },
});

export const addEmailUploads = makeRequestAction('ADD_EMAIL_UPLOADS', {
  onSuccess(params, response) {
    return {
      files: response.map((file) => ({
        uid: file.hashedId,
        name: file.fileName,
        url: `${API_ROOT}/file-storage/${file.hashedId}`,
        source: file.source,
      })),
    };
  },
});
